import { HighlightLayer as BabylonHighlightLayer } from '@babylonjs/core/Layers/highlightLayer';
import { Color3 } from '@babylonjs/core/Maths/math.color';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Scene } from '@babylonjs/core/scene';

import ArticleNode from '../../nodes/articleNode';
import Settings from '../../settings/settings';

export default class HighlightDiscontinuedLayer {
  private color: Color3;
  private highlightLayer: BabylonHighlightLayer;
  private discontinuedArticles: ArticleNode[];
  private selected: string;
  private hovered: string;

  constructor(name: string, scene: Scene) {
    this.color = Settings.DISCONTINUED_COLOR_READONLY;
    this.discontinuedArticles = [];
    this.selected = null;
    this.hovered = null;
    this.highlightLayer = new BabylonHighlightLayer(name, scene, {
      isStroke: true,
      blurTextureSizeRatio: 0.7,
      mainTextureFixedSize: 2048,
    });
    this.highlightLayer.innerGlow = false;
  }

  public addHighlight(article: ArticleNode) {
    this.discontinuedArticles.push(article);
    this.refresh();
  }
  public refresh() {
    this.highlightLayer.removeAllMeshes();
    this.discontinuedArticles
      .filter((article) => article.id !== this.selected && article.id !== this.hovered)
      .forEach((article) => {
        article.allMeshes.forEach((mesh) => {
          try {
            this.highlightLayer.addMesh(mesh as Mesh, this.color);
          } catch (error) {
            console.debug('Mesh is not supported for highlighting.', mesh.name);
          }
        });
      });
  }

  public hoverIn(article: ArticleNode) {
    this.hovered = article.id;
    this.refresh();
  }
  public hoverOut() {
    this.hovered = null;
    this.refresh();
  }
  public select(article: ArticleNode) {
    this.selected = article.id;
    this.refresh();
  }
  public unselect() {
    this.selected = null;
    this.refresh();
  }

  public changeColor(color: Color3) {
    this.color = color;
    this.refresh();
  }
}
